import type { EmbedSharePanelProps } from './EmbedSharePanel'
import { EmbedSharePanel } from './EmbedSharePanel'
import type { QRCodeSharePanelProps } from './QRCodeSharePanel'
import { QRCodeSharePanel } from './QRCodeSharePanel'
import { useSharePanelContext } from './SharePanelContext'

export interface SharePanelViewProps
  extends EmbedSharePanelProps,
    QRCodeSharePanelProps {}

export function SharePanelView(props: SharePanelViewProps) {
  const sharePanelContext = useSharePanelContext()
  switch (sharePanelContext.view) {
    case 'embed':
      return <EmbedSharePanel onCopy={props.onCopy} url={props.url} />
    case 'qrcode':
      return (
        <QRCodeSharePanel
          filename={props.filename}
          url={props.url}
          onSave={props.onSave}
        />
      )
    case 'initial':
      return <></>
  }
}
